import { useEffect, useState } from "react";
import appData from "../data/appData.json";
import { DataStore } from "aws-amplify/datastore";
import { ContentPage } from "../models/index.js";

export const useContent = (id = "") => {
  const [content, setContent] = useState([]);

  useEffect(() => {
    getContentById(id).then((data) => setContent([data]));
  }, []);

  return content;
};

export const getContentById = async (id = "") => {
  if (!Object.keys(appData.RouteIds).includes(id)) return;
  return (await DataStore.query(ContentPage, (c) => c.uniqueName.eq(appData.RouteIds[id])))[0];
};

export default useContent;
